import React from 'react'

const UsersList = () => {
  return (
    <h1>UsersList</h1>
  )
}

export default UsersList